module.exports = __webpack_public_path__ + "static/img/胜利女神0056.8a5673f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/goddess2/胜利女神0056.png
// module id = /lhi
// module chunks = 1